import { useState, useEffect } from "react";
import { calculateAmount } from "../../utils/calculateAmount";

export const useStockForm = () => {
    const [form, setForm] = useState({
        stockId: "",
        scrip: "",
        date: "",
        rate: "",
        quantity: "",
        transactionType: "BUY",
        amount: "",
    });

    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        const { rate, quantity, transactionType } = form;
        const amount = calculateAmount(rate, quantity, transactionType);

        setForm((prev) => ({ ...prev, amount }));
    }, [form.rate, form.quantity, form.transactionType]);

    const updateField = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const resetForm = () => {
        setForm({
            stockId: "",
            scrip: "",
            date: "",
            rate: "",
            quantity: "",
            transactionType: "BUY",
            amount: "",
        });
        setIsEditing(false);
    };

    return {
        form,
        setForm,
        updateField,
        resetForm,
        isEditing,
        setIsEditing,
    };
};